import "./FooterContainer.scss";

const FooterContainer = (
    {
        children = null,
        footerRightContent,
    }
) => {

    return (
        <div className='page-footer'>
            {children}
            {footerRightContent}
        </div>
    );
};

export default FooterContainer;
